import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useCentralizedAuth } from '@/context/CentralizedAuthProvider';
import { handleAssessmentAccess } from '@/utils/assessment/assessmentAccess';
import { toast } from 'sonner';

const CTAButtons = () => {
  const navigate = useNavigate();
  const { user, isLoading } = useCentralizedAuth();

  const startAssessment = async () => {
    if (isLoading) {
      toast.info("Please wait while we check your account...");
      return;
    }
    
    await handleAssessmentAccess(navigate, user?.id);
  };

  return (
    <section className="py-12 px-4 sm:px-6 md:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Button 
            size="lg" 
            className="px-8 py-3 h-auto text-base" 
            onClick={startAssessment}
          >
            Start Assessment
          </Button>
          <Button 
            variant="outline" 
            size="lg" 
            className="px-8 py-3 h-auto text-base border-brand-blue text-brand-blue hover:bg-blue-50"
            onClick={() => navigate('/contact-us')}
          >
            Contact Us
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CTAButtons;
